export const Topics = {
    AUTH_STATE: 'auth.state',
    PUSH_STATE: 'push.state',
};
